import styles from "./Backdrop.module.scss";
// import { useDispatch } from "react-redux";
// import { toggleModal } from "redux/common/commonSlice";

const Backdrop = ({ onCancel }: { onCancel?: () => any }) => <div className={styles.backdrop} onClick={onCancel}></div>;

export default Backdrop;
